import React from 'react';
import { X, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAzureAIChat } from '@/contexts/AzureAIChatContext';
import { AzureFloatingButton } from './AzureFloatingButton';
import { AzureChatInterface } from './AzureChatInterface';

export const AzureAIChatWidget = () => {
  const { isOpen, closeWidget, clearMessages, messages } = useAzureAIChat();

  const handleClearChat = () => {
    if (window.confirm('Are you sure you want to clear the chat history?')) {
      clearMessages();
    }
  };

  return (
    <>
      {/* Floating Button - Always visible when widget is closed */}
      {!isOpen && <AzureFloatingButton />}

      {/* Floating Chat Window */}
      {isOpen && (
        <div
          className="fixed bottom-6 right-6 w-[400px] max-w-[calc(100vw-48px)] h-[600px] max-h-[calc(100vh-48px)] flex flex-col bg-white rounded-2xl shadow-2xl z-50 animate-in slide-in-from-bottom-4 fade-in-0 zoom-in-95 duration-200"
          style={{
            border: '1px solid rgba(226, 232, 240, 0.8)'
          }}
        >
          {/* Header */}
          <div className="px-6 py-4 border-b border-slate-200 flex-shrink-0 bg-white rounded-t-2xl">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-indigo-600 to-violet-600 flex items-center justify-center">
                  <span className="text-white font-bold text-sm">D</span>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-slate-900">
                    Digian AI Assistant
                  </h3>
                  <p className="text-xs text-slate-500">
                    Powered by digian AI
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                {messages.length > 0 && (
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={handleClearChat}
                    className="h-8 w-8 rounded-full hover:bg-slate-100"
                    title="Clear chat history"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                )}
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={closeWidget}
                  className="h-8 w-8 rounded-full hover:bg-slate-100"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>

          {/* Content Area */}
          <div className="flex-1 overflow-hidden">
            <AzureChatInterface />
          </div>
        </div>
      )}
    </>
  );
};
